export default __webpack_public_path__ + "static/media/pic36-after.d0abff8d.JPG";